import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const Features = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const t = translations[language];
  const isROPage = location.pathname === '/ro';
  const features = isROPage ? [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      ),
      title: t.roFeature1Title,
      description: t.roFeature1Desc,
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      title: t.roFeature2Title,
      description: t.roFeature2Desc,
      gradient: 'from-cyan-500 to-blue-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      title: t.roFeature3Title,
      description: t.roFeature3Desc,
      gradient: 'from-blue-500 to-indigo-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: t.roFeature4Title,
      description: t.roFeature4Desc,
      gradient: 'from-indigo-500 to-purple-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      ),
      title: t.roFeature5Title,
      description: t.roFeature5Desc,
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      title: t.roFeature6Title,
      description: t.roFeature6Desc,
      gradient: 'from-pink-500 to-rose-500'
    }
  ] : [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      ),
      title: t.feature1Title,
      description: t.feature1Desc,
      gradient: 'from-green-500 to-cyan-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      title: t.feature2Title,
      description: t.feature2Desc,
      gradient: 'from-cyan-500 to-blue-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      title: t.feature3Title,
      description: t.feature3Desc,
      gradient: 'from-blue-500 to-purple-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: t.feature4Title,
      description: t.feature4Desc,
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      ),
      title: t.feature5Title,
      description: t.feature5Desc,
      gradient: 'from-pink-500 to-red-500'
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: t.feature6Title,
      description: t.feature6Desc,
      gradient: 'from-red-500 to-orange-500'
    }
  ];

  const borderColor = isROPage ? 'border-blue-500/50' : 'border-green-500/50';
  const textColor = isROPage ? 'text-blue-400' : 'text-green-400';
  const gradientColor = isROPage ? 'from-blue-400 to-cyan-400' : 'from-green-400 to-cyan-400';
  const gradientLine = isROPage ? 'from-blue-500 to-cyan-500' : 'from-green-500 to-cyan-500';
  const bgColor = isROPage ? 'bg-gradient-to-b from-blue-50 via-cyan-50 to-white' : 'bg-black';
  const textMain = isROPage ? 'text-gray-900' : 'text-white';
  const textSecondary = isROPage ? 'text-gray-600' : 'text-gray-400';
  const cardBg = isROPage ? 'bg-white shadow-xl' : 'bg-gray-900/80 backdrop-blur-sm';
  const shadowColor = isROPage ? 'shadow-blue-500/50' : 'shadow-green-500/50';

  return (
    <section className={`py-24 ${bgColor} relative overflow-hidden ${isROPage ? 'text-gray-900' : 'text-white'}`}>
      {/* Background Pattern */}
      {!isROPage && <div className="absolute inset-0 security-grid opacity-5 animate-flicker"></div>}
      {isROPage && (
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 water-wave"></div>
        </div>
      )}
      
      {/* Radar Sweep Effect - only for CCTV */}
      {!isROPage && (
        <div className="absolute top-0 right-0 w-96 h-96 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full">
            <div className="absolute inset-0 border-2 border-green-500/30 rounded-full animate-radar-sweep" style={{ transformOrigin: 'center' }}></div>
            <div className="absolute inset-4 border-2 border-green-500/20 rounded-full animate-radar-sweep" style={{ animationDelay: '1s', transformOrigin: 'center' }}></div>
          </div>
        </div>
      )}

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className={`inline-block px-6 py-2 ${isROPage ? 'bg-blue-100 border-2 border-blue-400' : 'bg-black/60 border-2 border-green-500/50'} rounded mb-6`}>
            <span className={`${isROPage ? 'text-blue-700' : textColor} font-semibold font-mono text-sm tracking-wider`}>
              {isROPage ? t.roFeaturesBadge : t.featuresBadge}
            </span>
          </div>
          <h2 className={`text-5xl md:text-6xl font-extrabold mb-6 font-mono ${textMain}`}>
            {isROPage ? t.roFeaturesTitle : t.featuresTitle} <span className={`bg-gradient-to-r ${gradientColor} bg-clip-text text-transparent`}>
              {isROPage ? t.roFeaturesTitle2 : t.featuresTitle2}
            </span>
          </h2>
          <p className={`text-xl md:text-2xl ${textSecondary} max-w-3xl mx-auto font-mono`}>
            {isROPage ? t.roFeaturesSubtitle : t.featuresSubtitle}
          </p>
          <div className={`w-24 h-1 bg-gradient-to-r ${gradientLine} mx-auto mt-6 rounded-full`}></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`group relative ${cardBg} rounded-xl p-8 border-2 ${borderColor} hover:${isROPage ? 'border-blue-500/80' : 'border-green-500/60'} transition-all duration-500 transform hover:-translate-y-2 hover:scale-105 animate-slide-in-right`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Hover Effect */}
              {!isROPage && <div className="absolute inset-0 rounded-xl animate-motion-detection pointer-events-none"></div>}
              {isROPage && (
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-cyan-500/0 group-hover:from-blue-500/10 group-hover:to-cyan-500/10 rounded-xl transition-all duration-500 pointer-events-none"></div>
              )}
              
              <div className="relative z-10">
                <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-xl flex items-center justify-center mb-6 ${shadowColor} shadow-lg transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}>
                  <div className="text-white">
                    {feature.icon}
                  </div>
                </div>
                <h3 className={`text-2xl font-bold ${textMain} mb-4 font-mono`}>{feature.title}</h3>
                <p className={`${textSecondary} leading-relaxed`}>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

